export default __webpack_public_path__ + "static/media/ITV_Policy_Network_Usage.3042d999.png";